export default __webpack_public_path__ + "images/arn_df858c.svg";